import { apiRequest } from "./api.client";
import { ROUTES } from "../constants";

export interface DrugSearchResult {
  drug_id: string;
  drug_name: string;       // brand name
  generic_name: string;
  drug_type: string;
  strength: string;
  unit: string | null;
  is_controlled_substance: boolean;
}

export interface DrugDetail extends DrugSearchResult {
  manufacturer: string | null;
  clinic_id: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface DrugCreatePayload {
  drug_name: string;
  generic_name: string;
  drug_type: "tablet" | "capsule" | "liquid" | "injection" | "topical";
  manufacturer?: string;
  strength: string;
  unit?: string;
  is_controlled_substance?: boolean;
  clinic_id?: string;
}

const DRUG_SEARCH_MIN_LENGTH = 3;

const DrugAPI = {
  searchDrugs(q: string, options?: { signal?: AbortSignal }): Promise<DrugSearchResult[]> {
    if (q.trim().length < DRUG_SEARCH_MIN_LENGTH) return Promise.resolve([]);
    const params = new URLSearchParams({ q });
    return apiRequest<DrugSearchResult[]>(`${ROUTES.DRUGS}?${params}`, { signal: options?.signal });
  },

  getDrug(id: string): Promise<DrugDetail> {
    return apiRequest<DrugDetail>(ROUTES.DRUG(id));
  },

  createDrug(payload: DrugCreatePayload): Promise<DrugDetail> {
    return apiRequest<DrugDetail>(ROUTES.DRUGS, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  updateDrug(id: string, payload: Partial<DrugCreatePayload>): Promise<DrugDetail> {
    return apiRequest<DrugDetail>(ROUTES.DRUG(id), {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  deleteDrug(id: string): Promise<void> {
    return apiRequest<void>(ROUTES.DRUG(id), { method: "DELETE" });
  },
};

export default DrugAPI;
